import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api, { unwrap } from '../utils/api';
import { useCart } from '../context/CartContext';
import Icon from '../components/Icon';

export default function CheckoutSuccess() {
  const [sp] = useSearchParams();
  const { refresh } = useCart();
  const sessionId = sp.get('session_id');
  const orderId = sp.get('order_id');
  const orderToken = sp.get('token');
  const isFree = !sessionId && !!orderId;
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!sessionId && !orderId) { setErr('Missing order reference'); setLoading(false); return; }
    (async () => {
      try {
        let body;
        if (sessionId) {
          const r = await api.post('/cart/verify-session', { session_id: sessionId });
          body = unwrap(r);
        } else {
          const r = await api.get(`/cart/order/${orderId}`, { params: { token: orderToken } });
          body = unwrap(r);
        }
        setOrder(body);
        // Persist order locator so user can return to downloads
        const stored = JSON.parse(localStorage.getItem('itsasimcha_orders') || '[]');
        if (!stored.find(o => o.id === body._id)) {
          stored.unshift({ id: body._id, token: body.downloadToken, at: Date.now() });
          localStorage.setItem('itsasimcha_orders', JSON.stringify(stored.slice(0, 20)));
        }
        refresh();
      } catch (e) {
        const m = e?.response?.data?.body;
        setErr(typeof m === 'string' ? m : (sessionId
          ? 'Could not verify payment. If the charge went through, contact support with your Stripe receipt.'
          : 'Could not load your order. If you have your order email, you can use the link there to download.'));
      } finally {
        setLoading(false);
      }
    })();
  }, [sessionId, orderId, orderToken, refresh]);

  if (loading) return <div style={{ padding: 60, textAlign: 'center' }}>{isFree ? 'Preparing your downloads…' : 'Confirming your payment…'}</div>;
  if (err) return (
    <div style={{ maxWidth: 600, margin: '60px auto', padding: '0 20px', textAlign: 'center' }}>
      <h1>Something went wrong</h1>
      <p className="error-text">{err}</p>
      <p><Link to="/">Back to home</Link></p>
    </div>
  );

  return (
    <div style={{ maxWidth: 760, margin: '60px auto', padding: '0 20px' }}>
      <h1 style={{ textAlign: 'center', color: '#198754' }}>
        <Icon name="check_circle" style={{ marginRight: 8 }} />{Number(order.total || 0) === 0 ? 'Your order is ready' : 'Payment confirmed'}
      </h1>
      <p style={{ textAlign: 'center', color: '#666', fontSize: 17 }}>
        Thank you! Your downloads are below {Number(order.total || 0) === 0 ? '— and we also emailed you the links.' : ''}
      </p>
      <p style={{ textAlign: 'center', color: '#888', fontSize: 13 }}>
        Order #{String(order._id).slice(-8).toUpperCase()} — Total ${Number(order.total || 0).toFixed(2)}
      </p>

      <div style={{ display: 'grid', gap: 16, marginTop: 30 }}>
        {(order.items || []).map((item) => (
          <div key={item._id} style={{ background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 4px 20px rgba(0,0,0,.06)', display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 200 }}>
              <strong style={{ fontSize: 17 }}>{item.productId?.name || 'Invitation'}</strong>
              <p style={{ margin: '6px 0 0', color: '#666', fontSize: 14 }}>
                Your personalized version is ready to download.
              </p>
            </div>
            <Link
              className="btn-primary"
              to={`/download/${order._id}/${item._id}?token=${encodeURIComponent(order.downloadToken)}`}
            >
              Download
            </Link>
          </div>
        ))}
      </div>

      <p style={{ textAlign: 'center', marginTop: 30, fontSize: 13, color: '#888' }}>
        Bookmark this page — the download links will keep working. Lost them? Email system@itsasimcha.net with your order number.
      </p>
    </div>
  );
}
